import { render, staticRenderFns } from "./CSRConnectionsList.vue?vue&type=template&id=4222a2f2&scoped=true"
import script from "./CSRConnectionsList.vue?vue&type=script&lang=js"
export * from "./CSRConnectionsList.vue?vue&type=script&lang=js"
import style0 from "./CSRConnectionsList.vue?vue&type=style&index=0&id=4222a2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222a2f2",
  null
  
)

export default component.exports